import { useOutletContext } from "react-router-dom";
import CreativesReport from "../components/CreativesReport";
import { CreativeReport, CreativeReportSection } from "../types";
import { ISidebarItem } from "@/components/common/sidebar/SidebarItem";
import { Dispatch, SetStateAction } from "react";
import { TZDate } from "@date-fns/tz";
import { CreativeSectionConfiguration } from "@/types";

interface OutletContext {
  reportConfig: CreativeReport | null;
  setReportConfig: Dispatch<SetStateAction<CreativeReport | null>>;
  reportConfigLoading: boolean;
  reportConfigError: boolean;
  selectedSection: (CreativeReportSection & { overrideScroll?: boolean }) | null;
  setSelectedSection: (
    section: (CreativeReportSection & { overrideScroll?: boolean }) | null,
  ) => void;
  handleAddSection: (
    presetConfiguration?: Partial<CreativeSectionConfiguration>,
    title?: string,
  ) => Promise<void>;
  isAddingSection: boolean;
  allowedDateRange: {
    first_allowed_date: TZDate;
    last_allowed_date: TZDate;
  } | null;
  isAccountSynced: boolean;
  hideAddSectionButton?: boolean;
  selectedSidebarItem: ISidebarItem | null;
  isChatOpen: boolean;
  setIsChatOpen: (open: boolean) => void;
  isCreatingLabel: boolean;
  setIsCreatingLabel: (value: boolean) => void;
}

const ReportsRoute = () => {
  const {
    reportConfig,
    setReportConfig,
    reportConfigLoading,
    selectedSection,
    setSelectedSection,
    handleAddSection,
    isAddingSection,
    allowedDateRange,
    isAccountSynced,
    hideAddSectionButton,
    selectedSidebarItem,
    isChatOpen,
    setIsChatOpen,
    isCreatingLabel,
    setIsCreatingLabel,
  } = useOutletContext<OutletContext>();

  return (
    <CreativesReport
      isChatOpen={isChatOpen}
      setIsChatOpen={setIsChatOpen}
      reportConfig={reportConfig}
      setReportConfig={setReportConfig}
      reportConfigLoading={reportConfigLoading}
      selectedSection={selectedSection}
      setSelectedSection={setSelectedSection}
      handleAddSection={handleAddSection}
      isAddingSection={isAddingSection}
      allowedDateRange={allowedDateRange}
      isAccountSynced={isAccountSynced}
      hideAddSectionButton={hideAddSectionButton}
      selectedSidebarItem={selectedSidebarItem}
      isCreatingLabel={isCreatingLabel}
      setIsCreatingLabel={setIsCreatingLabel}
    />
  );
};

export default ReportsRoute;
